import axios from '@/zenky'
import storage from '@/storage'
import cachedState from '@/cachedState'

export default {
  namespaced: true,

  state: {
    visibleCategoriesTree: [],
    flatVisibleCategories: [],
  },

  getters: {
    visibleCategoriesTree(state) {
      return state.visibleCategoriesTree
    },

    flatVisibleCategories(state) {
      return state.flatVisibleCategories
    },
  },

  mutations: {
    setVisibleCategoriesTree(state, tree) {
      /**
       * @param {Array} tree
       */
      const filterOutHidden = tree => {
        const visible = tree.filter(c => !c.hidden);
        visible.forEach(parent => parent.children = filterOutHidden(parent.children));
        return visible
      }

      const flat = []

      const flatter = category => {
        if (category.children && category.children.length) {
          category.children.forEach(child => flatter(child))
        }

        flat.push(category)
      }

      const visible = filterOutHidden(tree);
      state.visibleCategoriesTree = visible
      visible.forEach(category => flatter(category))
      state.flatVisibleCategories = flat
    },
  },

  actions: {
    loadCategoriesTree({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const categories = cachedState.categories()

        if (categories !== null) {
          commit('setVisibleCategoriesTree', categories)
          dispatch('saveCategoriesToStorage', categories)

          return resolve(categories)
        }

        const activeCityId = storage.activeCityId()

        axios.get(`categories?treeview=1&with=media,seo${activeCityId ? '&city_id=' + activeCityId : ''}`)
          .then(({ data }) => {
            commit('setVisibleCategoriesTree', data.data)
            dispatch('saveCategoriesToStorage', data.data)

            resolve(data.data)
          })
          .catch(err => reject(err))
      })
    },

    saveCategoriesToStorage(context, tree) {
      return new Promise(resolve => {
        storage.visibleCategoriesTree(JSON.stringify(tree))
        resolve(tree)
      })
    },

    preloadCategoriesFromStorage({ commit }) {
      return new Promise((resolve, reject) => {
        let tree = []

        try {
          tree = JSON.parse(storage.visibleCategoriesTree())
        } catch (e) {
          tree = []
        }

        tree = tree || []

        commit('setVisibleCategoriesTree', tree)
        resolve(tree)
      })
    },

    searchCategories({ getters }, query) {
      return new Promise((resolve, reject) => {
        const lowercased = query.toString().toLowerCase()

        return resolve(
          getters.flatVisibleCategories.filter(c => c.name.toLowerCase().indexOf(lowercased) !== -1)
        )
      })
    },
  },
}
